import { BlobEntity } from '@epicuro-next/ataraxia/file';
import { OrderHeader } from '@epicuro-next/data/order-book';
import { IOrderProduct } from '@epicuro-next/models/order-book';
import { createAction, props } from '@ngrx/store';
import { Order, OrderItem } from 'graphql-api/baskets-api-interfaces';

import { actionsPrefix } from '../../prefix';

const orderDetailActionsPrefix = `${actionsPrefix}[Detail]`;

export const loadOrderDetails = createAction(
  `${orderDetailActionsPrefix} Load Order Details`,
);

export const loadOrderDetailsSuccess = createAction(
  `${orderDetailActionsPrefix} Load Order Details Success`,
  props<{
    details: Order;
    orderItems: OrderItem[];
    products: IOrderProduct[];
    orderHeader: OrderHeader;
  }>(),
);

export const loadOrderDetailsFailure = createAction(
  `${orderDetailActionsPrefix} Load Order Details Failure`,
  props<{ error: string }>(),
);

export const printOrderDetails = createAction(
  `${orderDetailActionsPrefix} Print Order Details Page`,
);

export const downloadOrderInvoices = createAction(
  `${orderDetailActionsPrefix} Download Order Invoices`,
);

export const downloadOrderInvoicesSuccess = createAction(
  `${orderDetailActionsPrefix} Download Order Invoices Success`,
  props<{ entities: Required<BlobEntity>[] }>(),
);

export const downloadOrderInvoicesFailure = createAction(
  `${orderDetailActionsPrefix} Download Order Invoices Failure`,
  props<{ failedFiles: string[] }>(),
);

export const resetOrderDetailsState = createAction(
  `${orderDetailActionsPrefix} Reset Order Detail State`,
);
